<template>
    <layout-gestao>
        <layers-list
            :moduleId="moduleCode"
        />
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'

    export default {
        mixins: [mixin],
        components: {
            LayersList: () => import(/* webpackChunkName: "recursive-list" */ '@/app/shared/components/layers/List'),
        },
    }
</script>

<style scoped lang="scss">

</style>
